// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2318":"7177aeb1","2367":"054119f2","4692":"d5e79295","8042":"1332cbcf"}[chunkId] + ".chunk.css";
};